import { useEffect, useRef, useState } from "react";

/** Animates a number from 0 → value on first mount (rAF, ~700ms, eased). */
export function useCountUp(value, { duration = 700, enabled = true } = {}) {
  const [display, setDisplay] = useState(enabled ? 0 : value);
  const done = useRef(false);
  useEffect(() => {
    if (!enabled || done.current || typeof value !== "number" || !isFinite(value)) {
      setDisplay(value);
      return;
    }
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      setDisplay(value); done.current = true; return;
    }
    done.current = true;
    const t0 = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - t0) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(value * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, duration, enabled]);
  return display;
}
